import { ListTodo, X } from "lucide-react";
import { useTranslations } from "next-intl";
import { TodoRow, type ParsedTodo } from "./ToolComponents";
import { Badge } from "@/components/shadcn/badge";

interface TodoPanelProps {
  todos: Array<{ id?: string; content: string; status: string }>;
  onClose: () => void;
}

export function TodoPanel({ todos, onClose }: TodoPanelProps) {
  const t = useTranslations("widget.composer");
  const pendingCount = todos.filter((t) => t.status !== "completed").length;

  return (
    <div className="w-96 max-h-80 flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between px-3 py-2 border-b">
        <div className="flex items-center gap-2">
          <ListTodo className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm font-medium">Tasks</span>
          {pendingCount > 0 && (
            <Badge variant="secondary" className="text-[10px] px-1.5 py-0">
              {pendingCount} remaining
            </Badge>
          )}
        </div>
        <button
          onClick={onClose}
          className="p-0.5 rounded hover:bg-accent text-muted-foreground"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>

      {/* Todo list */}
      {todos.length > 0 ? (
        <div className="overflow-y-auto px-3 py-2 space-y-0.5">
          {todos.map((todo, i) => (
            <TodoRow key={(todo as any).id || i} todo={todo as ParsedTodo} />
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-8 text-muted-foreground gap-1">
          <ListTodo className="h-6 w-6 opacity-40" />
          <span className="text-xs">{t("noTasks")}</span>
        </div>
      )}
    </div>
  );
}
